import { useFormik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import edit from "../assets/images/icons/edit.png";
import PageHeader from "../Components/PageHeader";
import Table from "../Components/Table";
import TableContent from "../Components/TableContent";
import TableHeader from "../Components/TableHeader";
import * as Yup from "yup";
import InputField from "../Components/InputField";
import request, { URL } from "../services/request";
import endPoint from "../services/endPoint";
import { AppContext } from "../services/context";
import Notify from "../Components/Notify";
import tag from "../assets/images/tag.png";
import shopping from "../assets/images/shopping.png";
import group from "../assets/images/group.png";
import { toast } from "react-toastify";

const initData = {
  label: "",
  marque: "",
  annee: "",
  image: "",
  description: "",
};
const Model = () => {
  const authCtx = useContext(AppContext);
  const { user } = authCtx;
  const [datas, setDatas] = useState([]);
  const [marques, setMarques] = useState([]);
  const [annees, setAnnees] = useState([]);
  const [editId, setEditId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [viewData, setViewData] = useState({});
  const modal = useRef();
  const header = {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  useEffect(() => {
    getAll();
    getMarque();
    getAnnee();
  }, [refresh]);
  const validateData = Yup.object({
    label: Yup.string()
      .min(3, "Le nom de la model doit contenir 3 caractères ou moins")
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    marque: Yup.object().required(
      "Ce champ est obligatoire. Veuillez le remplir pour continuer"
    ),
    annee: Yup.object().required(
      "Ce champ est obligatoire. Veuillez le remplir pour continuer"
    ),
    description: Yup.string()
      .min(3, "La description doit contenir 3 caractères ou moins")
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    /*image: Yup.mixed()
      .required("Une image est requise")
      .test(
        "fileFormat",
        "Seuls les fichiers jpeg, png et gif sont autorisés",
        (value) => {
          return (
            value &&
            ["image/jpeg", "image/png", "image/gif"].includes(value.type)
          );
        }
      )
      .test("fileSize", "La taille maximale autorisée est de 2 Mo", (value) => {
        return value && value.size <= 2 * 1024 * 1024;
      }),*/
  });
  const formik = useFormik({
    initialValues: initData,
    validationSchema: validateData,
    onSubmit: (values) => {
      console.log(values);
      values.marque = values.marque?.value;
      values.annee = values.annee?.value;
      if (editId === "") {
        handleSubmit(values);
      } else {
        values._method = "put";
        handleEditSubmit(values);
      }
    },
  });

  const getAll = () => {
    request
      .get(endPoint.models, header)
      .then((res) => {
        setDatas(res.data.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getMarque = () => {
    request
      .get(endPoint.marques, header)
      .then((res) => {
        const tab = res.data.data.map((data) => {
          return { ...data, value: data.slug, label: data.label };
        });
        setMarques(tab);
        console.log(tab);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getAnnee = () => {
    request
      .get(endPoint.annees, header)
      .then((res) => {
        const tab = res.data.data.map((data) => {
          return { ...data, value: data.slug, label: data.label };
        });
        setAnnees(tab);
        console.log(tab);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSubmit = (values) => {
    toast.promise(request.post(endPoint.models, values, header), {
      pending: "Veuillez patienté...",
      success: {
        render({ data }) {
          console.log(data);
          const res = data;
          modal.current.click();
          getAll();

          return res.data.message;
        },
      },
      error: {
        render({ data }) {
          console.log(data);
          if (data?.response?.data?.message) {
            return data?.response?.data?.message;
          }
          return data?.response?.data?.errors
            ? data?.response?.data?.errors
            : data?.response?.data?.error;
        },
      },
    });
  };
  const handleEditSubmit = (values) => {
    //setShowModal(true)
    console.log(values);
    toast.promise(
      request.post(endPoint.models + "/" + editId, values, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;
            modal.current.click();
            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const onDelete = () => {
    toast.promise(
      request.delete(endPoint.models + "/" + viewData.slug, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;

            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const addModal = (e) => {
    e.preventDefault();
    setEditId("");
    formik.resetForm();
  };
  return (
    <>
      {/**
       * <div className="row">
        <div className="col-12">
          <div className="row row-cols-1 row-cols-sm-4">
            {[
              { name: "Marques", img: tag },
              { name: "Models", img: tag },
              { name: "Années", img: tag },
            ].map((data, idx) => {
              return (
                <div className="col mb-3" key={idx}>
                  <div className="card btn-primary-light p-4">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        <h6 className="text-16 fw-bold fs-4">{data.name}</h6>
                      </div>
                      <div className="ms-auto">
                        <img width="40px" src={data.img} alt="" />
                      </div>
                    </div>
                    <div>
                      <span>145</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
       */}
      <PageHeader title="Liste des marques" modal="form" addModal={addModal} />
      <Table>
        <TableHeader>
          <th scope="col" className="border-raduis-left">
            #
          </th>
          <th scope="col">Logo</th>
          <th scope="col">Model</th>
          <th scope="col">Marque</th>
          <th scope="col">Année</th>
          <th scope="col">Description</th>
          <th scope="col" className="text-center">
            Actions
          </th>
        </TableHeader>
        <TableContent>
          {datas.map((data, idx) => {
            return (
              <tr key={idx}>
                <td>
                  <input type="checkbox" value="selected" />
                </td>
                <td className="fw-bold">
                  <img
                    width="64px"
                    height="64px"
                    className="rounded"
                    src={URL + data.image}
                    alt=""
                  />
                </td>
                <td className="fw-bold">{data.label}</td>
                <td className="fw-bold">{data.marque.label}</td>
                <td className="fw-bold">{data.annee.label}</td>
                <td className="fw-bold">{data.description}</td>
                <td className="text-center">
                  <div className="btn-group">
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#view"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-eye-fill"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#form"
                        onClick={(e) => {
                          formik.setFieldValue("label", data.label);
                          formik.setFieldValue("marque", {
                            ...data,
                            value: data.marque.slug,
                            label: data.marque.label,
                          });
                          formik.setFieldValue("annee", {
                            ...data,
                            value: data.annee.slug,
                            label: data.annee.label,
                          });
                          formik.setFieldValue("description", data.description);
                          setEditId(data.slug);
                        }}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-pencil-square"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#delete"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          <i className="bi bi-trash3-fill"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </TableContent>
      </Table>
      <div className="modal fade" id="form">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                {editId !== "" ? "Modification d’un model" : "Ajout d’un model"}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={formik.handleSubmit}>
                <InputField
                  type={"text"}
                  name="label"
                  formik={formik}
                  placeholder="Nom du model"
                  label={"Model"}
                />

                <InputField
                  type={"react-select"}
                  name="marque"
                  formik={formik}
                  placeholder="Sélectionnez une marque"
                  label={"Marque"}
                  options={marques}
                />

                <InputField
                  type={"react-select"}
                  name="annee"
                  formik={formik}
                  placeholder="Sélectionnez une année"
                  label={"Année"}
                  options={annees}
                />

                <InputField
                  type={"file"}
                  name="image"
                  formik={formik}
                  placeholder="Choisir une image"
                  label={"Image du model"}
                />

                <InputField
                  type={"textaera"}
                  name="description"
                  formik={formik}
                  placeholder="Description du model"
                  label={"Description"}
                />

                <div className="d-flex justify-content-start border-0">
                  <button
                    type="reset"
                    className="btn btn-primary-light me-2"
                    data-bs-dismiss="modal"
                    ref={modal}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Enregistrer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">Suppression</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div>Voulez-vous supprimer définitivement les données ?</div>
              <div className="mt-4 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  data-bs-dismiss="modal"
                >
                  Non
                </button>
                <button
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={onDelete}
                >
                  Oui
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="view">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                Informations
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body text-center1">
              <div className="mb-3">
                <img width={"40%"} src={URL + viewData.image} />
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Model : </span>
                <span className="d-inline-block">{viewData.label}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Marque : </span>
                <span className="d-inline-block">{viewData.marque?.label}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Année : </span>
                <span className="d-inline-block">{viewData.annee?.label}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">
                  Description :{" "}
                </span>
                <span className="d-inline-block">{viewData.description}</span>
              </div>
              <div className="mt-4 d-flex justify-content-end">
                <button className="btn btn-primary" data-bs-dismiss="modal">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Notify showModal={showModal} />
    </>
  );
};

export default Model;
